/* ==================== 基础颜色（0-31 关：经典鲜艳） ==================== */

const TEAL = '#00c8ff';
const RGBA_TEAL = 'rgba(0, 200, 255, 0.3)';

const YELLOW = '#f1fa04';
const RGBA_YELLOW = 'rgba(255, 255, 0, 0.3)';

const PURPLE = '#d31ac1';
const RGBA_PURPLE = 'rgba(211, 26, 193, 0.3)';

const BLUE = '#5050ff';
const RGBA_BLUE = 'rgba(80, 80, 255, 0.3)';

const ORANGE = '#ffa500';
const RGBA_ORANGE = 'rgba(255, 127, 0, 0.3)';

const GREEN = '#0afa04';
const DARK_GREEN = '#5c9d31';
const RGBA_GREEN = 'rgba(0, 255, 0, 0.3)';

const RED = '#ff3b30';
const RGBA_RED = 'rgba(255, 59, 48, 0.3)';

const CORAL = '#e64a19';
const RGBA_CORAL = 'rgba(230, 74, 25, 0.3)';

const BLACK = '#444';
const RGBA_BLACK = 'rgba(0, 0, 0, 0.3)';

const WHITE = '#fff';
const RGBA_WHITE = 'rgba(255, 255, 255, 0.3)';

const PINK = '#ff4fa3';
const RGBA_PINK = 'rgba(255, 79, 163, 0.3)';

const VIOLET = '#7b34eb';
const RGBA_VIOLET = 'rgba(123, 52, 235, 0.3)';

const CYAN = '#0cc0df';
const RGBA_CYAN = 'rgba(12, 192, 223, 0.3)';

/* ==================== 32-63 关：暖色（WARM） ==================== */

const WARM_TEAL = '#ff6b6b';
const WARM_GREEN = '#ffa502';
const WARM_ORANGE = '#ffd700';
const WARM_YELLOW = '#ff7f50';
const WARM_BLUE = '#ff4757';
const WARM_PINK = '#ff6348';
const WARM_RED = '#e74c3c';
const WARM_VIOLET = '#f39c12';

/* ==================== 64-95 关：冷色（COOL） ==================== */

const COOL_TEAL = '#00d2d3';
const COOL_GREEN = '#1dd1a1';
const COOL_ORANGE = '#54a0ff';
const COOL_YELLOW = '#5f27cd';
const COOL_BLUE = '#01a3a4';
const COOL_PINK = '#0abde3';
const COOL_RED = '#48dbfb';
const COOL_VIOLET = '#2e86de';

/* ==================== 96-127 关：糖果色（CANDY） ==================== */

const CANDY_TEAL = '#f368e0';
const CANDY_GREEN = '#ff9ff3';
const CANDY_ORANGE = '#feca57';
const CANDY_YELLOW = '#ff9f43';
const CANDY_BLUE = '#ee5a24';
const CANDY_PINK = '#f78fb3';
const CANDY_RED = '#cf6a87';
const CANDY_VIOLET = '#e056a0';

/* ==================== 128-159 关：森林色（FOREST） ==================== */

const FOREST_TEAL = '#26de81';
const FOREST_GREEN = '#20bf6b';
const FOREST_ORANGE = '#2bcbba';
const FOREST_YELLOW = '#0fb9b1';
const FOREST_BLUE = '#45aaf2';
const FOREST_PINK = '#4b7bec';
const FOREST_RED = '#a55eea';
const FOREST_VIOLET = '#8854d0';

/* ==================== 160-191 关：日落色（SUNSET） ==================== */

const SUNSET_TEAL = '#ff6b35';
const SUNSET_GREEN = '#f7c59f';
const SUNSET_ORANGE = '#e08e45';
const SUNSET_YELLOW = '#d4a373';
const SUNSET_BLUE = '#cc8b5c';
const SUNSET_PINK = '#b56576';
const SUNSET_RED = '#a45c5c';
const SUNSET_VIOLET = '#8b5e3c';

/* ==================== 192-223 关：霓虹色（NEON） ==================== */

const NEON_TEAL = '#ff00ff';
const NEON_GREEN = '#00ffff';
const NEON_ORANGE = '#ffff00';
const NEON_YELLOW = '#ff0080';
const NEON_BLUE = '#00ff80';
const NEON_PINK = '#8000ff';
const NEON_RED = '#ff8000';
const NEON_VIOLET = '#0080ff';

/* ==================== 224-256 关：宝石色（JEWEL） ==================== */

const JEWEL_TEAL = '#00d2d3';
const JEWEL_GREEN = '#2ed573';
const JEWEL_ORANGE = '#ffa502';
const JEWEL_YELLOW = '#ff6348';
const JEWEL_BLUE = '#1e90ff';
const JEWEL_PINK = '#ff6b81';
const JEWEL_RED = '#ff4757';
const JEWEL_VIOLET = '#7b68ee';

/* ==================== 导出 ==================== */

const COLORS = {
  // 基础
  TEAL,
  RGBA_TEAL,
  YELLOW,
  RGBA_YELLOW,
  PURPLE,
  RGBA_PURPLE,
  BLUE,
  RGBA_BLUE,
  ORANGE,
  RGBA_ORANGE,
  GREEN,
  DARK_GREEN,
  RGBA_GREEN,
  RED,
  RGBA_RED,
  CORAL,
  RGBA_CORAL,
  BLACK,
  RGBA_BLACK,
  WHITE,
  RGBA_WHITE,
  PINK,
  RGBA_PINK,
  VIOLET,
  RGBA_VIOLET,
  CYAN,
  RGBA_CYAN,

  // WARM
  WARM_TEAL,
  WARM_GREEN,
  WARM_ORANGE,
  WARM_YELLOW,
  WARM_BLUE,
  WARM_PINK,
  WARM_RED,
  WARM_VIOLET,

  // COOL
  COOL_TEAL,
  COOL_GREEN,
  COOL_ORANGE,
  COOL_YELLOW,
  COOL_BLUE,
  COOL_PINK,
  COOL_RED,
  COOL_VIOLET,

  // CANDY
  CANDY_TEAL,
  CANDY_GREEN,
  CANDY_ORANGE,
  CANDY_YELLOW,
  CANDY_BLUE,
  CANDY_PINK,
  CANDY_RED,
  CANDY_VIOLET,

  // FOREST
  FOREST_TEAL,
  FOREST_GREEN,
  FOREST_ORANGE,
  FOREST_YELLOW,
  FOREST_BLUE,
  FOREST_PINK,
  FOREST_RED,
  FOREST_VIOLET,

  // SUNSET
  SUNSET_TEAL,
  SUNSET_GREEN,
  SUNSET_ORANGE,
  SUNSET_YELLOW,
  SUNSET_BLUE,
  SUNSET_PINK,
  SUNSET_RED,
  SUNSET_VIOLET,

  // NEON
  NEON_TEAL,
  NEON_GREEN,
  NEON_ORANGE,
  NEON_YELLOW,
  NEON_BLUE,
  NEON_PINK,
  NEON_RED,
  NEON_VIOLET,

  // JEWEL
  JEWEL_TEAL,
  JEWEL_GREEN,
  JEWEL_ORANGE,
  JEWEL_YELLOW,
  JEWEL_BLUE,
  JEWEL_PINK,
  JEWEL_RED,
  JEWEL_VIOLET,
};

export default COLORS;
